export const BUCKETS = {
    bucketAssets: 'brandfactory-assets'
};
